<template>
  <div class="container">
    <div v-show="!pay_success">
      <div class="res_head">
        <div class="res_head__fixed">
          <div class="res_head__fixed__box">
            <div class="res_header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
            <div class="res_header__fixed__center">
              <div class="enname">{{order_stadium_en_name}}</div>
              <div class="chname">{{order_stadium_name}}</div>
            </div>
            <div class="res_header__fixed__right"></div>
          </div>
        </div>
      </div>
      <div v-show="loaded==true">
        <!-- 会员卡列表 -->
        <div class="bb_reserve_switch_card">
          <div class="bb_reserve_switch_card_block">
            <swiper class="bb_reserve_switch_card_block_swiper" ref="mySwiperipSwitcCard" :options="swiperOptionsCards">
              <swiper-slide class="bb_reserve_switch_card_block_swiper_item" :style="'background-image: url('+carditem.thumb+')'"  v-for="(carditem,index) in my_card_list" :key="index">
                <div class="bb_reserve_switch_card_block_swiper_item_txt">
                  <div class="bb_reserve_switch_card_block_swiper_item_txt_cont">
                    <div class="bb_reserve_switch_card_block_swiper_item_txt_name">
                      &nbsp;
                    </div>
                    <div class="bb_reserve_switch_card_block_swiper_item_txt_msg">
                      <div class="bb_reserve_switch_card_block_swiper_item_txt_msg_1">{{carditem.msg_3}}</div>
                      <div class="bb_reserve_switch_card_block_swiper_item_txt_msg_2">
                        {{carditem.msg_1}}
                        <span>{{(carditem.end_date).replace(/-/g,".")}}到期</span>
                      </div>
                      <div v-if="carditem.bind_username==null||carditem.bind_username==undefined||carditem.bind_username==''"
                        class="bb_reserve_switch_card_block_swiper_item_txt_msg_3">
                        {{carditem.msg_2}}
                        <span>NO.&nbsp;{{carditem.cards_no}}</span>
                      </div>
                      <div v-else class="bb_reserve_switch_card_block_swiper_item_txt_msg_3">
                        {{carditem.bind_username}} {{carditem.bind_mobile}}
                        <span>NO.&nbsp;{{carditem.cards_no}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
            <!-- myCard_index -->
            <div v-show="myCard_index>0" class="swiper-button-prev"></div>
            <div v-show="myCard_index+1<my_card_list.length" class="swiper-button-next"></div>
          </div>
        </div>
        <!-- 个人信息 -->
        <div class="rserves_hpage_fit_order_info">
          <div class="rserves_hpage_fit_order_info_block">
            <div class="rserves_hpage_fit_order_info_block_myinfo">
              <div class="rserves_hpage_fit_order_info_block_myinfo_title">预约类型</div>
              <div class="rserves_hpage_fit_order_info_block_myinfo_value" v-show="order_type=='fit'">沸健身 (高端酒店游泳健身)</div>
              <div class="rserves_hpage_fit_order_info_block_myinfo_value" v-show="order_type=='yoga'">翡瑜伽 (高端酒店瑜伽)</div>
              <div class="clearboth"></div>
            </div>
            <div class="rserves_hpage_fit_order_info_block_myinfo">
              <div class="rserves_hpage_fit_order_info_block_myinfo_title">日期</div>
              <div class="rserves_hpage_fit_order_info_block_myinfo_value">{{create_date}}&nbsp;{{create_date_week}}</div>
              <div class="clearboth"></div>
            </div>
            <div class="rserves_hpage_fit_order_info_block_myinfo" v-if="order_type=='yoga'">
              <div class="rserves_hpage_fit_order_info_block_myinfo_title">课程</div>
              <div class="rserves_hpage_fit_order_info_block_myinfo_value">{{order_courser.sd_course_name}} &nbsp; {{(order_courser.start_time).substring(11,16)}}-{{(order_courser.end_time).substring(11,16)}}</div>
              <div class="clearboth"></div>
            </div>
            <div class="rserves_hpage_fit_order_info_block_myinfo" v-if="order_type=='fit'">
              <div class="rserves_hpage_fit_order_info_block_myinfo_title">到店时间</div>
              <div @click="selecetPickTime()" class="rserves_hpage_fit_order_info_block_myinfo_value_arriveTime">{{vt_showSelectPickTimeTXT}}<label></label></div>
              <div class="clearboth"></div>
            </div>
            <div class="rserves_hpage_fit_order_info_block_myinfo">
              <div class="rserves_hpage_fit_order_info_block_myinfo_title">会员</div>
              <div class="rserves_hpage_fit_order_info_block_myinfo_value">{{userinfo_name}} &nbsp; {{userinfo_mobile}}</div>
              <div class="clearboth"></div>
            </div>
          </div>
        </div>
        <!-- 随行亲友 -->
        <div class="rserves_hpage_fit_order_guest" v-if="order_type=='fit'">
          <div class="rserves_hpage_fit_order_guest_block">
            <div class="rserves_hpage_fit_order_guest_block_title">
              <van-row>
                <van-col span="12" class="guesttitle">同行亲友</van-col>
                <van-col span="12" class="guessteperUp">
                  <span @click="reduceGuest()" class="guessteperUp_reduce">-</span>
                  <span class="guessteperUp_num">{{guestNum}}</span>
                  <span @click="addGuest()" class="guessteperUp_add">+</span>
                </van-col>
              </van-row>
              <div class="rserves_hpage_fit_order_guest_block_title_guest" v-show="guestNum>0">
                <van-row class="guestnum_dist" v-for="(item,index) in extraInfo" :key="index">
                  <van-col span="12" class="guesttitle">
                    <span @click="reduceGuestSp(item,index)" class="guessteperUp_reduce">-</span>
                    亲友
                  </van-col>
                  <van-col span="12" class="guessteperUp">
                    <input type="text" maxlength="20" class="guessteperUp_inputname" v-model="extraInfo[index]" placeholder="请输入亲友姓名" />
                  </van-col>
                </van-row>
              </div>
            </div>
          </div>
        </div>
        <div class="rserves_hpage_fit_order_guest" v-else>
          <div class="rserves_hpage_fit_order_guest_block">
            <div class="rserves_hpage_fit_order_guest_block_title">
              <van-row>
                <van-col span="12" class="guesttitle">同行亲友</van-col>
                <van-col span="12" class="guessteperUp">
                  <span @click="reduceGuest()" class="guessteperUp_reduce">-</span>
                  <span class="guessteperUp_num">{{guestNum}}</span>
                  <span @click="addGuest()" class="guessteperUp_add">+</span>
                </van-col>
              </van-row>
            </div>
          </div>
        </div>
        <!-- 价格 -->
        <div class="co">
          <div class="co_block">
            <div v-if="order_type=='fit'" class="co_block_item co_block_item_border">
              <van-row class="co_block_item_row">
                <van-col span="12" class="co_block_item_row_title">
                  优惠券
                  <label v-show="bb_coupon_list.length>0&&mycoupon_select_idx != ''" class="co_block_item_row_bold_select">已选一个</label>
                </van-col>
                <van-col span="12" class="co_block_item_row_txt">
                  <label v-show="bb_coupon_list.length==0">暂无可选优惠券</label>
                  <label v-show="bb_coupon_list.length>0&&mycoupon_select_idx == ''">可选择优惠券</label>
                  <label v-show="bb_coupon_list.length>0&&mycoupon_select_idx != ''">{{mycoupon_select}}</label>
                  <label class="co_block_item_row_txt_arrow">&nbsp;&nbsp;</label>
                  <button @click="openCoupon()" v-preventReClick class="co_block_item_row_txt_btn"></button>
                </van-col>
              </van-row>
            </div>
            <div class="co_block_item co_block_item_border">
              <van-row class="co_block_item_row">
                <van-col span="12" class="co_block_item_row_title">价格</van-col>
                <van-col span="12" class="co_block_item_row_txt">
                  <div v-if="fl_priceInfo.master_free_times>0">会员 扣除权益1次</div>
                  <div v-else>会员 &nbsp; ¥{{(parseFloat(fl_priceInfo.master_pay_fee,10)/100).toFixed(2)}}/人</div>
                  <div v-show="guestNum>0 && fl_priceInfo.guest_pay_fee>0" class="co_block_item_row_txt_dis">亲友 &nbsp; ¥{{fl_priceInfo_friend}}/人 × {{guestNum}}</div>
                  <div v-show="guestNum>0 && fl_priceInfo.guest_pay_fee==0" class="co_block_item_row_txt_dis">亲友 扣除权益{{guestNum}}次</div>
                  <div v-if="order_type=='fit'" class="co_block_item_row_txt_dis">门市价 &nbsp; ¥{{originppppp}}/人</div>
                  <div v-else class="co_block_item_row_txt_dis">门市价 &nbsp; ¥200/人</div>
                  <div v-show="false" class="co_block_item_row_txt_dis">优惠券 &nbsp; -¥{{mycoupon_select}}</div>
                </van-col>
              </van-row>
            </div>
            <div class="co_block_item">
              <van-row class="co_block_item_row">
                <van-col span="12" class="co_block_item_row_bold">
                  支付金额
                </van-col>
                <van-col span="12" class="co_block_item_row_color">
                  <div class="co_block_item_row_color_price">¥{{need_pay}}</div>
                  <!-- <div v-show="need_pay-mycoupon_select>=0" class="co_block_item_row_color_price">¥{{(need_pay-mycoupon_select).toFixed(2)}}</div>
                  <div v-show="need_pay-mycoupon_select<0" class="co_block_item_row_color_price">¥0</div> -->
                  <div class="co_block_item_row_color_save">本次为您节省{{save_pay}}元</div>
                </van-col>
              </van-row>
            </div>
          </div>
        </div>
        <!-- 预约说明 -->
        <ExplainFit v-show="order_type=='fit'" />
        <div v-if="order_type=='yoga'" class="explain_shabiyaoqiu">
          <div v-if="fuck_stadium_id==100042||fuck_stadium_id=='100042'">
            退订说明：请在距离开课时间3小时前免费退订，超出视为已使用。
            <br /><br />
            预约声明：该酒店规定瑜伽用户可于开课前20分钟领取更衣室钥匙，课程完毕后40分钟内需归还更衣室钥匙。瑜伽用户上课仅限于使用更衣柜、毛巾、拖鞋、沐浴。如使用游泳池、按摩池、桑拿房、健身器材等设施需要个人向酒店单独支付240元。
            <br /><br />
            提交预约代表我已以阅读并知晓<label @click="openshabi()" class="explain_shabiyaoqiu_sb">《瑜伽预约须知》</label>
          </div>
          <div v-else-if="fuck_stadium_id==100033||fuck_stadium_id=='100033'">
            退订说明：请在距离开课时间3小时前免费退订，超出视为已使用。
            <br /><br />
            预约声明：该酒店规定瑜伽用户可于开课前15分钟领取更衣室钥匙，课程完毕后30分钟内需归还更衣室钥匙。瑜伽用户上课仅限于使用更衣柜、毛巾、拖鞋、沐浴。如使用游泳池、按摩池、桑拿房、健身器材等设施需要个人向酒店单独支付380元。
            <br /><br />
            提交预约代表我已以阅读并知晓<label @click="openshabi()" class="explain_shabiyaoqiu_sb">《瑜伽预约须知》</label>
          </div>
          <div v-else>
            退订说明：请在距离开课时间3小时前免费退订，超出视为已使用。
            <br /><br />
            预约声明：瑜伽用户上课仅限于使用更衣柜、毛巾、拖鞋、沐浴。如使用游泳池、按摩池、桑拿房、健身器材等设施需要本人向酒店支付费用，收费标准以酒店告知为准。
            <br /><br />
            提交预约代表我已以阅读并知晓<label @click="openshabi()" class="explain_shabiyaoqiu_sb">《瑜伽预约须知》</label>
          </div>
        </div>
        <!-- <ExplainYoga v-show="order_type=='yoga'" /> -->

        <!-- 提交 -->
        <div v-if="order_type=='fit'" class="submit">
          <div class="submit_pos">
            <button @click="submitOrder()" v-preventReClick class="submit_pos_btn">提交</button>
            <!-- <div v-if="order_type=='fit'" class="submit_pos_tip">退订说明：请在{{create_refund_date}} 23:59前申请退订，过期将不可退</div>
            <div v-else class="submit_pos_tip">退订说明：请在{{create_refund_date}} 前申请退订，过期将不可退</div> -->
            <div class="submit_pos_tip">退订说明：请在距离到店时间24小时前免费退订，超出视为已使用</div>
          </div>
        </div>
        <div v-else class="submitcnm">
          <div class="submit_pos">
            <button @click="submitOrder()" v-preventReClick class="submit_pos_btn">提交</button>
            <!-- <div v-if="order_type=='fit'" class="submit_pos_tip">退订说明：请在{{create_refund_date}} 23:59前申请退订，过期将不可退</div>
            <div v-else class="submit_pos_tip">退订说明：请在{{create_refund_date}} 前申请退订，过期将不可退</div> -->
            <!-- <div class="submit_pos_tip">退订说明：请在距离到店时间24小时前免费退订，超出视为已使用</div> -->
          </div>
        </div>

      </div>
      <!-- 时间选择器 -->
      <div class="vt_rserves_hpage_fit_order_picktimeMask" v-show="vtRservesHpageFitOrderPicktime_guili"></div>
      <div class="vt_rserves_hpage_fit_order_picktime" v-show="vtRservesHpageFitOrderPicktime_guili">
        <van-picker title="请选择入场时间" show-toolbar :columns="guili_columns" @confirm="onConfirmGuiLi" @cancel="onCancelGuiLi" />
      </div>
      <div class="vt_rserves_hpage_fit_order_picktimeMask" v-show="vtRservesHpageFitOrderPicktime"></div>
      <div class="vt_rserves_hpage_fit_order_picktime" v-show="vtRservesHpageFitOrderPicktime">
        <van-datetime-picker v-model="vt_pickTimeFOrEnter" type="time" title="选择时间" :min-hour="vtpicktime_minhourse" :max-hour="vtpicktime_maxhourse" :min-minute="0" :max-minute="30" :filter="vtRservesHpageFitOrderPicktime_filter" @cancel="vtPickTimeSelectCancel" @confirm="vtPickTimeSelect" />
      </div>
      <div class="vt_rserves_hpage_fit_order_picktimeMask" v-show="vtRservesHpageFitOrderPicktime_wst"></div>
      <div class="vt_rserves_hpage_fit_order_picktime" v-show="vtRservesHpageFitOrderPicktime_wst">
        <van-picker title="请选择入场时间" show-toolbar :columns="wst_columns" @confirm="onConfirmwWst" @cancel="onCancelWst" />
      </div>
      <!-- fuck -->
      <div @click="closeshcnm()" v-show="cnm" class="cnm_maks" @touchmove.prevent></div>
      <div v-show="cnm" class="cnm_cont">

        <div class="cnm_cont_itemm" v-if="fuck_stadium_id==100042||fuck_stadium_id=='100042'">
          <div class="cnm_cont_itemm_icon" @click="closeshcnm()">
            <img src="../../assets/images/fc/close.png" />
          </div>
          <div class="cnm_cont_item">《瑜伽预约须知》</div>
          1、请至少在开课前3小时预约课程，最多可提前预约3节课；<br />
          2、瑜伽在距离开课时间3小时前可免费退订，超出视为已使用不可退；<br />
          3、2人或者2人以上才开设课程；不满2人课程将在开课前3小时自动取消；<br />
          4、该酒店规定瑜伽用户可于开课前20分钟领取更衣室钥匙，课程完毕后40分钟内需归还更衣室钥匙。瑜伽用户上课仅限于使用更衣柜、毛巾、拖鞋、沐浴。如使用游泳池、按摩池、桑拿房、健身器材等设施需要个人向酒店单独支付240元；<br />
          5、根据酒店健身中心规定，为安全起见，瑜伽不接收年龄在65岁以上（包括65岁）的客人进入，未成年人下场时需成年人陪同进入；<br />
          6、不宜饱腹练习，练习完毕不宜马上进食和沐浴；<br />
          7、请您进入教室后保持安静，手机调成静音，至少开课前15分钟到达馆内做好上课准备，开课后10分钟后不得进入教室。<br />
        </div>
        <div class="cnm_cont_itemm" v-else-if="fuck_stadium_id==100033||fuck_stadium_id=='100033'">
          <div class="cnm_cont_itemm_icon" @click="closeshcnm()">
            <img src="../../assets/images/fc/close.png" />
          </div>
          <div class="cnm_cont_item">《瑜伽预约须知》</div>
          1、请至少在开课前3小时预约课程，最多可提前预约3节课；<br />
          2、瑜伽在距离开课时间3小时前可免费退订，超出视为已使用不可退；<br />
          3、2人或者2人以上才开设课程；不满2人课程将在开课前3小时自动取消；<br />
          4、该酒店规定瑜伽用户可于开课前15分钟领取更衣室钥匙，课程完毕后30分钟内需归还更衣室钥匙。瑜伽用户上课仅限于使用更衣柜、毛巾、拖鞋、沐浴。如使用游泳池、按摩池、桑拿房、健身器材等设施需要个人向酒店单独支付380元；<br />
          5、根据酒店健身中心规定，为安全起见，瑜伽不接收年龄在65岁以上（包括65岁）的客人进入，未成年人下场时需成年人陪同进入；<br />
          6、不宜饱腹练习，练习完毕不宜马上进食和沐浴；<br />
          7、请您进入教室后保持安静，手机调成静音，至少开课前15分钟到达馆内做好上课准备，开课后10分钟后不得进入教室。<br />

        </div>
        <div class="cnm_cont_itemm" v-else>
          <div class="cnm_cont_itemm_icon" @click="closeshcnm()">
            <img src="../../assets/images/fc/close.png" />
          </div>
          <div class="cnm_cont_item">《瑜伽预约须知》</div>
          1、请至少在开课前3小时预约课程，最多可提前预约3节课；<br />
          2、瑜伽在距离开课时间3小时前可免费退订，超出视为已使用不可退；<br />
          3、2人或者2人以上才开设课程；不满2人课程将在开课前3小时自动取消；<br />
          4、瑜伽用户上课仅限于使用更衣柜、毛巾、拖鞋、沐浴。如使用游泳池、按摩池、桑拿房、健身器材等设施需要本人向酒店支付费用，收费标准以酒店告知为准；<br />
          5、根据酒店健身中心规定，为安全起见，瑜伽不接收年龄在65岁以上（包括65岁）的客人进入，未成年人下场时需成年人陪同进入；<br />
          6、不宜饱腹练习，练习完毕不宜马上进食和沐浴；<br />
          7、请您进入教室后保持安静，手机调成静音，至少开课前15分钟到达馆内做好上课准备，开课后10分钟后不得进入教室。<br />

        </div>


      </div>
      <!-- 优惠券面板 -->
      <!--
        /**
          优惠券类型区分：
            consum_limit  1卖卡  2预约  3全部
            coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
            type 1自用  2邀约
            status 1 正常 4已过期 3已作废 2已使用 5已赠送
        */
       -->
      <div v-show="loaded==true" :class="[{'bb_coupon_listc_maskc':coupon_status==true},'bb_coupon_listc_mask']" @click="closeCouponListPanel()"></div>
      <div v-show="loaded==true" :class="[{'bb_coupon_reserve_hei':coupon_status==true},'bb_coupon bb_coupon_reserve']">
        <div v-if="bb_coupon_list.length>0" class="bb_coupon_item" v-for="(item,index) in bb_coupon_list" @click="selectCoupon(item)">
          <div class="bb_coupon_item_info" :style="'background-image: url('+coupon_zy_bg+')'">

            <!--
            优惠券类型区分：
              consum_limit  1卖卡  2预约  3全部
              coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
              type 1自用  2邀约
              status 1 正常 4已过期 3已作废 2已使用 5已赠送
             -->
            <div v-if="item.info.coupon_type==2" :class="[{'bb_coupon_item_info_leftlarge':JSON.stringify(item.info.amount).length>=3},'bb_coupon_item_info_left']">
              {{(item.info.discount)*10}}&nbsp;&nbsp;<span>折&nbsp;&nbsp;&nbsp;</span>
            </div>
            <div v-else-if="item.info.coupon_type==4" :class="[{'bb_coupon_item_info_leftlarge':JSON.stringify(item.info.amount).length>=3},'bb_coupon_item_info_left']">
              <div class="bb_coupon_item_info_left_ycqy">1次权益</div>
            </div>
            <div v-else :class="[{'bb_coupon_item_info_leftlarge':JSON.stringify(item.info.amount).length>=3},'bb_coupon_item_info_left']">
              <label>¥</label>{{item.info.amount}}
              <div v-show="item.info.coupon_type==3" class="bb_coupon_item_info_left_mj">满{{item.info.full}}可用</div>
            </div>



            <div class="bb_coupon_item_info_right">
              <div class="bb_coupon_item_info_right_info">
                <div class="bb_coupon_item_info_right_info_name">{{item.info.name}}</div>
                <div class="bb_coupon_item_info_right_info_time" style="color: #8F8C98">有效期至{{(item.end_date).replace(/-/g,".")}}</div>
              </div>
              <div class="bb_coupon_reserve_unselect" v-show="mycoupon_select_idx!=item.id"></div>
              <div class="bb_coupon_reserve_selected" v-show="mycoupon_select_idx==item.id"></div>
              <div class="clearboth"></div>
            </div>
            <div class="clearboth"></div>
          </div>
          <div class="bb_coupon_item_button">可与其他活动优惠同时享受</div>
        </div>
        <div v-if="bb_coupon_list.length==0" class="bb_coupon_empty">
          <img :src="coupon_empty" class="bb_coupon_empty_img" />
          <div class="bb_coupon_empty_tips">暂无优惠券哦～</div>
        </div>
      </div>
    </div>
    <div v-show="pay_success">
      <div class="head">
        <div class="head__fixed">
          <div class="head__fixed__box">
            <div class="header__fixed__left"><a href="javascript:history.go(-1)" class="back"></a></div>
            <div class="header__fixed__center">
              <h1>支付成功</h1>
            </div>
            <div class="header__fixed__right"></div>
          </div>
        </div>
      </div>
      <div class="vision_payresult">
        <img class="vision_payresult_img" src="../../assets/images/base/pay_success_icon.png" />
        <div v-if="order_type=='yoga'" class="vision_payresult_con">
          预约成功短信已发送至{{userinfo.mobile}}，请注意查收！若开课3小时前预约人数未达到开课人数，我们会取消订单并将退款原路返还至您的账户
        </div>
        <div v-else class="vision_payresult_con">
          预约成功短信已发送至手机{{userinfo.mobile}}，请注意查收！
        </div>
        <div class="vision_payresult_tip">
          注：使用时请在酒店前台出示您的验证码和本人身份证，如有疑问可咨询400-630-5888
        </div>
        <div class="vision_payresult_btn">
          <div class="vision_payresult_btn_order" @click="backOrder()">查看订单</div>
          <div class="vision_payresult_btn_index" @click="backHome()">返回首页</div>
          <div class="clearboth"></div>
        </div>

        <div v-show="order_type=='fit'" class="erweima">
          <div class="erweima1">长按二维码,加入游泳健身客户优惠群，领取更多福利，预订更优惠</div>
          <img class="erweima2" src="../../assets/images/fc/fit26.png" />
          <div class="erweima3">该二维码7天内(4月26日前) 有效，重新进入将更新</div>
        </div>

        <div v-show="order_type=='yoga'" class="erweima">
          <div class="erweima1">长按二维码,加入瑜伽客户优惠群，领取更多福利，预订更优惠</div>
          <img class="erweima2" src="../../assets/images/fc/yoga26.png" />
          <div class="erweima3">该二维码7天内(4月26日前) 有效，重新进入将更新</div>
        </div>







      </div>
    </div>
  </div>
</template>

<script>
  import ExplainFit from '../subgroup/appointmentExplainFit.vue'
  import ExplainYoga from '../subgroup/appointmentExplainYoga.vue'

  import {distance,getStValStatus} from '../../lib/utils.js'
  export default {
    components:{
      'ExplainFit':ExplainFit,
      'ExplainYoga':ExplainYoga
    },
    data() {
      var _this = this;
      return {
        cnm:false,
        loaded:false,//页面是否加载结束
        my_card_list:[],//我的会员卡列表
        myCard_index: 0, //我的会员卡索引
        myCard_current:{},//我的会员卡
        swiperOptionsCards: {
          on: {
            slideChangeTransitionEnd: function() {
              // // console.log(this.activeIndex)
              _this.myCard_index = this.activeIndex
              _this.myCard_current=_this.my_card_list[this.activeIndex]
              _this.mycoupon_select=0,//重置选择的优惠券价格
              _this.mycoupon_select_idx='',//重置已选择优惠券的id
              // _this.getTotalPrice()//切换会员卡后需要重新计算价格
              _this.FLResetGuest()//切换会员卡后重置嘉宾数量
              _this.getPanelUserInfo()//更新个人信息
            }
          },
          navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
          },
        },
        order_type:'',//订单类型
        order_stadium:null,//订单场馆信息
        order_date:null,//订单日期
        order_courser:null,//订单课程
        userinfo:{},//用户信息
        order_stadium_en_name:'',//当前场馆en_name
        order_stadium_name:'',//当前场馆name
        create_date:'',//订单日期
        create_date_week:'',//周几
        create_refund_date:'',//退订日期

        guestNum:0,//亲友数量
        extraInfo:[],//亲友数组

        need_pay:0,//需要支付金额
        save_pay:0,//节省金额

        bb_coupon_list:[],//我的优惠券
        mycoupon_select:0,//选择的优惠券价格
        mycoupon_select_idx:'',//已选择优惠券的id
        coupon_zy_bg:require('../../assets/images/base/coupon_ziyong_up.png'),
        coupon_empty:require('../../assets/images/base/coupon_empty.png'),
        coupon_status:false,//优惠券面板状态

        vtRservesHpageFitOrderPicktime:false,//时间选择器
        vt_showSelectPickTimeTXT:'请选择到店时间',
        vt_pickTimeFOrEnter:'',
        vtpicktime_minhourse:0,
        vtpicktime_maxhourse:0,
        vtRservesHpageFitOrderPicktime_guili:false,
        guili_columns:['06:30','08:30','10:30','12:30','14:30','16:30','18:30','20:30'],
        vtRservesHpageFitOrderPicktime_wst:false,
        wst_columns:['06:00','08:30','11:00','13:30','16:00','18:30','21:00'],

        pay_success:false,//是否支付成功

        userinfo_name:'',//显示面板姓名
        userinfo_mobile:'',//显示面板手机号
        fl_priceInfo:{},//价格数据
        fl_priceInfo_friend:0,//亲友价格
        originppppp:0,//门市价

        mycoupon_select_type:0,//选中优惠券类型
        mycoupon_select_num:0,//优惠金额
        fuck_stadium_id:''
      }
    },
    created() { },
    mounted() {
      document.title = '斐燃生活——畅享五星级奢华酒店游泳/健身/瑜伽';
      this.getUserInfo()
      this.getCoupon()
      this.shareApp()
    },
    watch:{
      "guestNum":function(){
        if (this.guestNum > this.extraInfo.length) {
          for (let i = this.extraInfo.length; i < parseInt(this.guestNum); i++) {
            this.extraInfo[i] = "";
          }
        } else {
          this.extraInfo.splice(this.guestNum, this.extraInfo.length - this.guestNum);
        }
      }
    },
    activated() { },
    methods: {
      closeshcnm(){
        this.cnm=false
      },
      openshabi(){
        console.log('shabi')
        this.cnm=true
      },
      // 获取个人信息
      getUserInfo(){
        var $this = this
        // this.$loading('信息加载中~');
        let param = {
          token: localStorage.getItem("token")
        }
        var qs = require('qs');
        let url = this.api.userApi.getInfo
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // console.log(result)
          if (result.data) {
            $this.userinfo = result.data.user
            $this.getCardList()
          } else {
            // $this.$loading.close()
            $this.$toast(result.msg)
            $this.getCardList()
          }
        }).catch((error) => {
          // // console.warn(error)
          // $this.$loading.close()
          // $this.$toast('error');
        })
      },
      // 获取用户优惠券
      getCoupon(){
        // getCouponList
        var $this = this
        $this.bb_coupon_list=[]
        let param = {
          token:localStorage.getItem("token"),
          page:1,
          offset:100,
          type:1,
          consum_rule:2,
          status:1
        }
        var qs = require('qs');
        let url = this.api.userApi.getCouponList
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result.data.coupons.data)
          if (result.data) {
            // $this.bb_coupon_list=result.data.coupons.data
            /**
              优惠券类型区分：
                consum_limit  1卖卡  2预约  3全部
                coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
                type 1自用  2邀约
                status 1 正常 4已过期 3已作废 2已使用 5已赠送
            */
            for (var i = 0; i < result.data.coupons.data.length; i++) {
              if(result.data.coupons.data[i].consum_limit==2 || result.data.coupons.data[i].consum_limit==3){
                if(new Date((result.data.coupons.data[i].start_date).replace(/-/g,'/')).getTime()<=new Date().getTime()){
                  // $this.coupon_list.push(result.data.coupons.data[i])
                  $this.bb_coupon_list.push(result.data.coupons.data[i])
                }

              }
            }
          } else {
            $this.$toast(result.msg)
          }
        }).catch((error) => {
          // console.warn(error)
          // $this.$toast('error');
        })
      },
      // 获取个人卡列表
      getCardList(){
        var $this = this

        // // console.log($this.$store.state.list_myCards)
        // $this.$store.commit('setMyCards',result.data.cards)
        // // console.log($this.$store.state.list_myCards)
        if($this.$store.state.array_mycard.length==0){
          this.$loading('信息加载中');
          let param = {
            token: localStorage.getItem("token")
          }
          var qs = require('qs');
          let url = this.api.userApi.flUserCardsList
          this.axios.post(url, qs.stringify(param), )
          .then((result) => {
            // console.log(result)
            if (result.data) {
              $this.$store.commit('updataMycard',result.data)
              $this.my_card_list=result.data
              // $this.$store.commit('setMyCards',result.data.cards)
              if(result.data.length>0){
                $this.myCard_current=result.data[0]
              }
              $this.loadStadiumInfo()
              console.log($this.myCard_current)
              console.log(getStValStatus($this.myCard_current.bind_username))
              if(getStValStatus($this.myCard_current.bind_username).code==0){
                $this.userinfo_name=$this.userinfo.name
                $this.userinfo_mobile=$this.userinfo.mobile
              }else{
                $this.userinfo_name=$this.myCard_current.bind_username
                $this.userinfo_mobile=$this.myCard_current.bind_mobile
              }
              setTimeout(function(){
                $this.loaded=true
                $this.$loading.close()
              },500)
            } else {
              $this.$loading.close()
              $this.$toast(result.msg)
              $this.loaded=true
            }
          }).catch((error) => {
            // // console.warn(error)
            $this.$loading.close()
            $this.loaded=true
            // $this.$toast('error');
          })
        }else{
          var curlist=$this.$store.state.array_mycard
          $this.my_card_list=curlist
          // $this.$store.commit('setMyCards',result.data.cards)
          if(curlist.length>0){
            $this.myCard_current=curlist[0]
          }
          $this.loadStadiumInfo()
          console.log($this.myCard_current)
          console.log(getStValStatus($this.myCard_current.bind_username))
          if(getStValStatus($this.myCard_current.bind_username).code==0){
            $this.userinfo_name=$this.userinfo.name
            $this.userinfo_mobile=$this.userinfo.mobile
          }else{
            $this.userinfo_name=$this.myCard_current.bind_username
            $this.userinfo_mobile=$this.myCard_current.bind_mobile
          }
          setTimeout(function(){
            $this.loaded=true
            $this.$loading.close()
          },500)
        }




        // userinfo_name:'',//显示面板姓名
        //         userinfo_mobile:'',//显示面板手机号
      },
      // 更新用户面板信息
      getPanelUserInfo(){
        var $this=this
        if(getStValStatus($this.myCard_current.bind_username).code==0){
          $this.userinfo_name=$this.userinfo.name
          $this.userinfo_mobile=$this.userinfo.mobile
        }else{
          $this.userinfo_name=$this.myCard_current.bind_username
          $this.userinfo_mobile=$this.myCard_current.bind_mobile
        }
      },
      // 加载订单数据
      loadStadiumInfo(){
        // // // console.log(sessionStorage.getItem('create_order_type'))
        // // // console.log(JSON.parse(sessionStorage.getItem('stadium_current')))
        // console.log(JSON.parse(sessionStorage.getItem('stadium_current')))
        // 将缓存中数据赋值
        this.order_type=sessionStorage.getItem('create_order_type');//订单类型
        this.order_stadium=JSON.parse(sessionStorage.getItem('stadium_current'));//订单场馆
        this.order_stadium_en_name=(JSON.parse(sessionStorage.getItem('stadium_current'))).en_name;//当前场馆en_name
        this.order_stadium_name=(JSON.parse(sessionStorage.getItem('stadium_current'))).name;//当前场馆name

        this.originppppp=(parseFloat(this.order_stadium.origin_price,10)/100).toFixed(2)
        // (parseFloat(order_stadium.origin_price,10)/100).toFixed(2)

        if(sessionStorage.getItem('create_order_type')=='fit'){
          // // // console.log(JSON.parse(sessionStorage.getItem('select_fit_date')))
          this.order_date=JSON.parse(sessionStorage.getItem('select_fit_date'));//订单日期
        }else{
          // // // console.log(JSON.parse(sessionStorage.getItem('select_yoga_date')))
          // console.log(JSON.parse(sessionStorage.getItem('current_yoga_course')))
          this.order_date=JSON.parse(sessionStorage.getItem('select_yoga_date'));//订单日期
          this.order_courser=JSON.parse(sessionStorage.getItem('current_yoga_course'));//订单课程
        }
        // 加载个人信息模块
        let week = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六'];
        if(sessionStorage.getItem('create_order_type')=='fit'){
          // // // console.log(JSON.parse(sessionStorage.getItem('select_fit_date')))
          this.create_date=(JSON.parse(sessionStorage.getItem('select_fit_date'))).date
          this.create_date_week=week[new Date((JSON.parse(sessionStorage.getItem('select_fit_date'))).date).getDay()]
          // var week = weekArray[new Date(date).getDay()]; //注意此处必须是先new一个Date

        }else{
          // // console.log(JSON.parse(sessionStorage.getItem('select_yoga_date')))
          this.create_date=(JSON.parse(sessionStorage.getItem('select_yoga_date'))).date
          this.create_date_week=week[new Date((JSON.parse(sessionStorage.getItem('select_yoga_date'))).date).getDay()]
        }
        this.getTotalPrice()
        this.refundDate()
        this.pickTime()

        this.caonima()
      },
      caonima(){
        console.log(this.order_stadium)
        this.fuck_stadium_id=this.order_stadium.stadium_id
      },
      // 日期选择器
      pickTime(){
        // console.log(this.order_stadium)
        // 通常状况下的开始时间
        if(getStValStatus(this.order_stadium.business_start_time).stat==false){
          this.vtpicktime_minhourse=10
          this.vt_pickTimeFOrEnter="10:00"
          // // console.log(1)
        }else{
          var stime=(this.order_stadium.business_start_time).substring(0,2)
          // // console.log(parseInt(stime,10))
          this.vtpicktime_minhourse=parseInt(stime,10)
          // // console.log(2)
        }
        // 判断下单日期是否为当日，若为当日，则下单时间点根据当前时间的实际情况选择
        // // console.log(this.create_date)
        var today_date=new Date()
        var today_date_year=today_date.getFullYear()
        var today_date_month=today_date.getMonth()+1
        if(today_date_month<10){today_date_month='0'+today_date_month}
        var today_date_day=today_date.getDate()
        if(today_date_day<10){today_date_day='0'+today_date_day}
        var today_date_date=today_date_year+'-'+today_date_month+'-'+today_date_day
        if(today_date_date==this.create_date){
          // // console.log('当日')
          // // console.log(today_date.getHours()+2)

          // if(this.order_stadium.stadium_id=='100050'){
          //   this.vtRservesHpageFitOrderPicktime_guili=true
          // }else if(this.order_stadium.stadium_id=='100045'){
          //   this.vtRservesHpageFitOrderPicktime_wst=true
          // }else{
          //   this.vtRservesHpageFitOrderPicktime=!this.vtRservesHpageFitOrderPicktime
          // }
          // // console.log(this.order_stadium.stadium_id)
          if(this.order_stadium.stadium_id=='100050'){
            //瑰丽
            // // console.log('瑰丽当日可预约时间段')
            var hour=today_date.getHours()
            // guili_columns:['06:30','08:30','10:30','12:30','14:30','16:30','18:30','20:30'],
            for (var i = 0; i < this.guili_columns.length; i++) {
              var hour_index=this.guili_columns[i].substring(0,2)
              parseInt(hour_index,10)
              if(hour<=hour_index){
                // // console.log(i)
                this.guili_columns.splice(0,i+1)
                break
              }
            }
          }else if(this.order_stadium.stadium_id=='100045'){
            // 威斯汀
            // // console.log('威斯汀当日可预约时间段')
            var hour=today_date.getHours()
            // wst_columns:['06:00','08:30','11:00','13:30','16:00','18:30','21:00'],
            for (var i = 0; i < this.wst_columns.length; i++) {
              var hour_index=this.wst_columns[i].substring(0,2)
              parseInt(hour_index,10)
              if(hour<=hour_index){
                // // console.log(i)
                this.wst_columns.splice(0,i+1)
                break
              }
            }
          }else{
            // console.log(3)
            // console.log(today_date)
            // console.log(today_date.getMinutes())
            if(today_date.getMinutes()<=30){
              var hour=0
              if(today_date.getHours()>21){
                hour=23
              }else{
                hour=today_date.getHours()+2
              }
              // var hour=today_date.getHours()+2

              // console.log(hour)
              this.vtpicktime_minhourse=hour
              this.vt_pickTimeFOrEnter=hour+":00"
            }else{
              var hour=0
              if(today_date.getHours()>20){
                hour=23
              }else{
                hour=today_date.getHours()+3
              }
              // var hour=today_date.getHours()+3
              // console.log(today_date.getHours())
              // console.log(hour)

              // console.log(hour)
              this.vtpicktime_minhourse=hour
              this.vt_pickTimeFOrEnter=hour+":00"
            }
          }
        }else{
          // // console.log('非当日')
        }
        // 结束时间
        if(getStValStatus(this.order_stadium.business_end_time).stat==false){
          this.vtpicktime_maxhourse=18
        }else{
          var etime=(this.order_stadium.business_end_time).substring(0,2)
          // // console.log(parseInt(etime,10))
          var litime=parseInt(etime,10) - 2
          this.vtpicktime_maxhourse=litime
        }

      },
      // 退订日期
      refundDate(){
        // // console.log(sessionStorage.getItem('create_order_type'))
        // .replace(/-/g,".")
        // // console.log(this.order_courser)
        if(sessionStorage.getItem('create_order_type')=='fit'){
          var create_date=this.create_date.replace(/-/g,"/")
          var sssssss = (new Date(create_date)).getTime() - 24*60*60*1000*2;
          var sss = new Date(sssssss)
          var getYear=sss.getFullYear()
          var getMonth=sss.getMonth()+1
          if(getMonth<10){getMonth='0'+getMonth}
          var getDate=sss.getDate()
          if(getDate<10){getDate='0'+getDate}
          // // console.log(sss.getFullYear()+'-'+getMonth+'-'+sss.getDate())
          this.create_refund_date=getYear+'-'+getMonth+'-'+getDate
        }else{
          var retime=this.order_courser.start_time
          // // console.log(retime)
          // // console.log(retime.substring(0,10))
          var trttime=parseInt(retime.substring(11,13),10)-4
          // // console.log(trttime)
          if(trttime<10){trttime='0'+trttime}
          trttime=trttime+':59'
          this.create_refund_date=retime.substring(0,10)+' '+trttime
        }

      },
      // 减少亲友
      reduceGuest(){
        if(this.guestNum>0){
          // // console.log('减少亲友')
          // 重置优惠券的选择
          if(this.guestNum<2){
            this.mycoupon_select=0;//选择的优惠券价格
            this.mycoupon_select_idx=''//已选择优惠券的id
          }
          // return
          this.guestNum--
          this.getTotalPrice()
        }
      },
      // 减少亲友（行间）
      reduceGuestSp(item,index){
        // // console.log('减少亲友-行')
        // 重置优惠券的选择
        if(this.guestNum<2){
          this.mycoupon_select=0;//选择的优惠券价格
          this.mycoupon_select_idx=''//已选择优惠券的id
        }
        // return
        this.extraInfo.splice(index, 1)
        this.guestNum--
        this.getTotalPrice()
      },
      // 增加亲友
      addGuest(){
        var maxnum=0;//最多携带嘉宾数量
        if(this.my_card_list.length>0){
          if(this.myCard_current.guest_num_limit<=2){
            maxnum=this.myCard_current.guest_num_limit
          }else{
            maxnum=2
          }
        }else{
          maxnum=2
        }

        if(this.guestNum==maxnum){
          this.$toast('最多可携带' + maxnum + '位嘉宾');
        }
        if(this.guestNum<maxnum){
          this.guestNum++
          this.getTotalPrice()
        }
      },
      // 重置嘉宾数量
      FLResetGuest(){
        this.mycoupon_select=0;//选择的优惠券价格
        this.mycoupon_select_idx=''//已选择优惠券的id
        this.guestNum=0
        this.getTotalPrice()
      },
      // 计算价格
      getTotalPrice(){
        var $this=this
        // var pay_price=0;//支付金额
        // var save_price=0;//节省金额
        // this.need_pay=pay_price
        // this.save_pay=save_price
        this.$loading('价格计算中');
        // console.log(this.myCard_current)
        // console.log(this.order_stadium)
        var num=1+this.guestNum
        var origin_price=0
        if(this.order_type=='fit'){
          origin_price=((parseFloat(this.order_stadium.origin_price,10))/100).toFixed(2)
        }else{
          origin_price=200
        }
        let param = {
          token: localStorage.getItem("token"),
          user_cards_id:this.myCard_current.id,
          num:num,
          item_fee:origin_price
        }
        // // console.log(param)
        var qs = require('qs');
        let url = this.api.userApi.flUserCardsOrderFee
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // console.log(result)
          if (result.data) {

            /**
                优惠券类型区分：
                  consum_limit  1卖卡  2预约  3全部
                  coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
                  type 1自用  2邀约
                  status 1 正常 4已过期 3已作废 2已使用 5已赠送
             */

            // $this.need_pay=0
            // // this.mycoupon_select_type
            // coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
            // this.mycoupon_select_num
            // console.log($this.mycoupon_select_type)
            if($this.mycoupon_select_type==4){
              $this.need_pay=((parseFloat(result.data.guest_pay_fee,10)) / 100).toFixed(2)
            }else if($this.mycoupon_select_type==3){
              $this.need_pay=(((parseFloat(result.data.pay_total_fee,10)) / 100) - (parseFloat($this.mycoupon_select_num,10))).toFixed(2)
            }else if($this.mycoupon_select_type==2){
              $this.need_pay=(((parseFloat(result.data.pay_total_fee,10)) / 100) * (parseFloat($this.mycoupon_select_num,10))).toFixed(2)
            }else if($this.mycoupon_select_type==1){
              $this.need_pay=(((parseFloat(result.data.pay_total_fee,10)) / 100) - parseFloat($this.mycoupon_select_num,10)).toFixed(2)
            }else if($this.mycoupon_select_type==0){
              $this.need_pay=((parseFloat(result.data.pay_total_fee,10)) / 100)
            }else{
              $this.need_pay=((parseFloat(result.data.pay_total_fee,10)) / 100)
            }
            if($this.need_pay<0){
              $this.need_pay=0
            }
            // old
            // $this.need_pay=0//(((parseFloat(result.data.pay_total_fee,10))/100)-parseFloat($this.mycoupon_select,10)).toFixed(2)


            $this.save_pay=(((parseFloat(result.data.total_fee,10)/100) - parseFloat($this.need_pay,10))).toFixed(2)
            $this.fl_priceInfo=result.data
            $this.fl_priceInfo_friend=(((parseFloat(result.data.guest_pay_fee,10)/100))/$this.guestNum).toFixed(2)
            // mycoupon_select
            setTimeout(function(){
              $this.$loading.close()
            },300)
          } else {
            $this.$loading.close()
            // $this.$toast(result.msg)
            $this.$dialog.confirm({
              title:'温馨提示',
              showCancelButton:false,
              message: result.msg,
              confirmButtonColor: '#544590',
              confirmButtonText:'',
            }).then(() => {

            }).catch(() => {

            })
          }
        }).catch((error) => {
          $this.$loading.close()
        })
        return
        // // // console.log('此处价格计算')
        // // // // console.log(this.myCard_current)
        // // // console.log(this.order_stadium)
        // // // console.log('门市价'+this.order_stadium.origin_price)
        // // // // console.log('会员价'+this.myCard_current.fee)
        // // // console.log('亲友数量'+this.guestNum)
        // // // console.log('亲友价'+this.myCard_current.guest_fee)
        // // // console.log('亲友能否使用免费权益'+this.myCard_current.is_use_guest_role)
      },
      // 打开优惠券
      openCoupon(){
        if(this.bb_coupon_list.length>0){
          // // console.log('可以打开')
          this.coupon_status=!this.coupon_status
        }
      },
      // 选择优惠券
      selectCoupon(item){
        // console.log(item)
        if(this.mycoupon_select_idx==item.id){
          this.mycoupon_select=''
          this.mycoupon_select_idx=''
          this.mycoupon_select_num=0
          this.coupon_status=!this.coupon_status
          this.mycoupon_select_type=0
          this.getTotalPrice()
          return
        }
        if(this.need_pay==0 && this.mycoupon_select_idx==''){
          this.$toast('金额已经最低了，不需要再使用优惠券了')
          this.coupon_status=!this.coupon_status
          return
        }
        // return
        /**
            优惠券类型区分：
              consum_limit  1卖卡  2预约  3全部
              coupon_type 1代金券  2 折扣 3满减 4 抵用 【1amount  2discount  3full amount  4只能预约】
              type 1自用  2邀约
              status 1 正常 4已过期 3已作废 2已使用 5已赠送
         */

        //
        // 满减折扣判断
        if(item.info.coupon_type==3 && this.need_pay<item.info.full){
          this.$toast('待支付金额满'+item.info.full+'即可使用此券')
          return
        }

        // console.log(this.fl_priceInfo)


        // $this.fl_priceInfo

        if(item.info.coupon_type==4){//抵用


          if(this.fl_priceInfo.master_pay_fee>0){
            this.mycoupon_select='1次权益'
            this.mycoupon_select_idx=item.id
            this.mycoupon_select_num='1次权益'
          }else{
            this.$toast('已使用会员折扣权益，不可再使用抵扣券')
            return
          }

        }else if(item.info.coupon_type==3){//满减
          this.mycoupon_select='-¥'+parseFloat(item.info.amount,10)
          this.mycoupon_select_idx=item.id
          this.mycoupon_select_num=item.info.amount
        }else if(item.info.coupon_type==2){//折扣
          this.mycoupon_select='享受 '+((parseFloat(item.info.discount,10))*10)+' 折优惠'
          this.mycoupon_select_idx=item.id
          this.mycoupon_select_num=item.info.discount
        }else{//代金券
          this.mycoupon_select='-¥'+parseFloat(item.info.amount,10)
          this.mycoupon_select_idx=item.id
          this.mycoupon_select_num=item.info.amount
        }
        // this.mycoupon_select=parseFloat(item.info.amount,10)
        // this.mycoupon_select_idx=item.id



        this.mycoupon_select_type=item.info.coupon_type
        //

        // if(this.mycoupon_select==item.info.amount){
        //   this.mycoupon_select=0
        //   this.mycoupon_select_idx=''
        // }else{
        //   this.mycoupon_select=parseFloat(item.info.amount,10)
        //   this.mycoupon_select_idx=item.id
        // }
        this.coupon_status=!this.coupon_status
        this.getTotalPrice()
      },
      // 关闭优惠券面板
      closeCouponListPanel(){
        this.coupon_status=!this.coupon_status
      },
      // 提交
      submitOrder(){
        if(this.order_type=='fit'){
          // // console.log('健身')
          if(this.vt_showSelectPickTimeTXT=='请选择到店时间'){
            this.$toast('请选择到店时间')
            return
          }
          for (var i = 0; i < this.extraInfo.length; i++) {
            if(this.extraInfo[i]==''){
              this.$toast('请完输入嘉宾信息')
              return
            }
          }
          // // console.log(this.order_stadium)
          // // // console.log(this.myCard_current)
          // // // console.log(this.guestNum)
          var order_cnt=this.guestNum+1
          var pushname=''
          if(getStValStatus(this.myCard_current.bind_username).stat==false){
            pushname=this.userinfo.name
          }else{
            pushname=this.myCard_current.bind_username
          }
          var pushphone=''
          if(getStValStatus(this.myCard_current.bind_mobile).stat==false){
            pushphone=this.userinfo.mobile
          }else{
            pushphone=this.myCard_current.bind_mobile
          }
          var extra_info=''
          for (var i = 0; i < this.extraInfo.length; i++) {
            extra_info = extra_info + this.extraInfo[i] + ','
          }
          extra_info = extra_info.substring(0, extra_info.length - 1)
          var param={
            token: localStorage.getItem("token"),
            sd_area_id: sessionStorage.getItem('sd_area_id'),
            date:this.create_date,
            order_cnt:order_cnt,
            user_cards_id:this.myCard_current.id,
            name: pushname,
            mobile: pushphone,
            extra_info:extra_info,
            user_coupon_id:this.mycoupon_select_idx,
            time:this.vt_showSelectPickTimeTXT
          }
          this.fitSubmitOrderJu(param)//健身下单前弹框判断
        }else{
          // // console.log('瑜伽')
          // let param = {
          //   token: localStorage.getItem("token"),
          //   stadium_id: this.current_stdium.stadium_id,
          //   sd_course_schedule_id: this.select_yoga_date_course.sd_course_schedule_id,
          //   order_cnt: order_cnt,
          //   user_cards_id: this.my_current_card.id,
          //   name: pushname,
          //   mobile: pushphone,
          //   user_coupon_id:this.select_coupon_mySelected_idx
          // }

          // // // console.log(this.order_stadium)
          // // // console.log(this.myCard_current)
          // // // console.log(this.guestNum)
          // // // console.log(this.order_courser)

          var order_cnt=this.guestNum+1
          var pushname=''
          if(getStValStatus(this.myCard_current.bind_username).stat==false){
            pushname=this.userinfo.name
          }else{
            pushname=this.myCard_current.bind_username
          }
          var pushphone=''
          if(getStValStatus(this.myCard_current.bind_mobile).stat==false){
            pushphone=this.userinfo.mobile
          }else{
            pushphone=this.myCard_current.bind_mobile
          }
          var param={
            token: localStorage.getItem("token"),
            stadium_id:this.order_stadium.stadium_id,
            sd_course_schedule_id:this.order_courser.sd_course_schedule_id,
            order_cnt:order_cnt,
            user_cards_id:this.myCard_current.id,
            name: pushname,
            mobile: pushphone,
            user_coupon_id:this.mycoupon_select_idx,
          }
          // // console.log(param)
          this.yogaSubmitOrderJu(param)
        }
      },
      // 健身下单前弹框判断
      fitSubmitOrderJu(param){
        var $this= this
        // // console.log(param)
        // // console.log((param.date).replace(/-/g,"/"))
        // 判断：下场日期为今日或明日，会给用户提示
        var xiadan_date=(this.create_refund_date).replace(/-/g,"/")
        var pdate=new Date()
        var pdate_year = pdate.getFullYear()
        var pdate_month = pdate.getMonth() + 1
        if(pdate_month<10){pdate_month='0'+pdate_month}
        var padte_day = pdate.getDate()
        var dangqian_date=pdate_year+'/'+pdate_month+'/'+padte_day
        // // console.log(new Date(xiadan_date).getTime() - new Date(dangqian_date).getTime())
        if(new Date(xiadan_date).getTime() >= new Date(dangqian_date).getTime()){
          this.fitSubmitOrder(param)
        }else{
          this.$dialog.confirm({
            message: "您预约的是当天或第二天的日期，预订成功后将不可退订，请确认是否要继续预约？",
            confirmButtonColor: '#544590'
          }).then(() => {
            // // console.log('确定')
            $this.fitSubmitOrder(param)
          }).catch(() => {
            // // console.log('取消')
          })
        }
      },
      // 健身下单
      fitSubmitOrder(param){
        // // console.log(param)
        // // console.log(this.api.userApi.bookFit)
        // // console.log(this.order_stadium)
        var parameter={
          stadium_id:this.order_stadium.stadium_id,
          date:param.date,
          time:param.time,
          user_cards_id:param.user_cards_id,
          user_coupon_id:param.user_coupon_id,
          guest:param.extra_info,
          token:param.token,
        }
        // return
        this.fitSubmitOrderBook(parameter)//v2.1.8后开始用新的下单接口，下面代码暂时停止执行
        return
        // orderFit
        var $this = this
        this.$loading('正在创建订单');
        // let param = param;
        var qs = require('qs');
        let url = this.api.userApi.orderFit
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // console.log(result)
          if(!result.data){
            $this.$toast(result.msg);
            $this.$loading.close()
          }else{
            if(result.data.pay_json == ""||result.data.pay_json == undefined||result.data.pay_json == null){
              var temp=[]
              setTimeout(() => {
                $this.$loading.close()
                $this.pay_success=true
                sessionStorage.removeItem('fullpage')
                // 我的会员卡列表发生变化，vuex 更新我的会员卡
                $this.$store.commit('setMyCards',temp)
              }, 300);
            }else{
              let config = JSON.parse(result.data.pay_json);
              // // console.log(config)
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1), false);
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1));
                  document.attachEvent('onWeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1));
                }
              } else {
                $this.onBridgeReady(config,result.data.order_no,1);
              }
            }
          }
        }).catch((error) => {
          // console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })
      },
      //v2.1.8后健身开始用新的下单接口
      fitSubmitOrderBook(param){
        // console.log(param)
        // return
        var $this = this
        this.$loading('正在创建订单');
        // let param = param;
        var qs = require('qs');
        let url = this.api.userApi.bookFit
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // console.log(result)
          if(!result.data){
            $this.$toast(result.msg);
            $this.$loading.close()
          }else{
            if(result.data.pay_type=='wx'&&result.data.pay_json!=''){
              let config = JSON.parse(result.data.pay_json);
              // // console.log(config)
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1), false);
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1));
                  document.attachEvent('onWeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,1));
                }
              } else {
                $this.onBridgeReady(config,result.data.order_no,1);
              }
            }else{
              $this.fitFreePay(result.data.order_no)
            }
          }
        }).catch((error) => {
          // console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })
      },
      // v2.1.8 免费权益次数
      fitFreePay(order_no){
        var $this = this
        let param = {
          token:localStorage.getItem("token"),
          order_no:order_no
        };
        var qs = require('qs');
        let url = this.api.userApi.bookFitFreePay
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // console.log(result)
          if(result.code==0){
            var temp=[]
            setTimeout(() => {
              $this.$loading.close()
              $this.pay_success=true
              $this.$store.commit('updataMycard', [])
              sessionStorage.removeItem('fullpage')
              // 我的会员卡列表发生变化，vuex 更新我的会员卡
              // $this.$store.commit('setMyCards',temp)
            }, 300);
          }else{
            $this.$loading.close()
            $this.$toast(result.msg);
          }
        }).catch((error) => {
          // console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })
      },
      // 瑜伽下单前弹框判断
      yogaSubmitOrderJu(param){
        var $this= this
        // // console.log(param)
        // // console.log(this.create_refund_date)
        // // console.log(this.order_courser)
        var pdate=new Date()
        var pdate_year = pdate.getFullYear()
        var pdate_month = pdate.getMonth() + 1
        var padte_day = pdate.getDate()
        if(pdate_month<10){pdate_month='0'+pdate_month}
        if(padte_day<10){padte_day='0'+padte_day}


        var pdate_hours=pdate.getHours()
        // // console.log(pdate_hours)
        // // console.log(parseInt((this.order_courser.start_time).substring(11,13),10))
        var theory_time=parseInt((this.order_courser.start_time).substring(11,13),10)-3
        // // console.log(theory_time)

        var todaytime=pdate_year+'/'+pdate_month+'/'+padte_day
        // // console.log(todaytime)
        // // console.log(((this.create_refund_date).substring(0,10)).replace(/-/g,'/'))
        // // console.log(new Date(todaytime).getTime())
        // // console.log(new Date(((this.create_refund_date).substring(0,10)).replace(/-/g,'/')).getTime())
        var oday=new Date(((this.create_refund_date).substring(0,10)).replace(/-/g,'/')).getTime()
        var tday=new Date(todaytime).getTime()



        // // console.log('--------------------')
        var pdatetimer=new Date().getTime() + 3*60*60*1000
        // // console.log(pdatetimer)
        // // console.log(this.order_courser.start_time)
        var ygstart_time=new Date((this.order_courser.start_time).replace(/-/g,'/')).getTime()
        // // console.log(ygstart_time)
        // // console.log(pdatetimer - ygstart_time)
        // return
        if(pdatetimer<ygstart_time){
          // // console.log(1)
          this.yogaSubmitOrder(param)
        }else{
          // // console.log(2)
          if(pdatetimer>ygstart_time){
            // // console.log(3)
              this.$dialog.confirm({
                message: "您预约的瑜伽课程距开课时间不足3小时，预订成功后将不可退订，请确认是否要继续预约？",
                confirmButtonColor: '#544590'
              }).then(() => {
                $this.yogaSubmitOrder(param)
              }).catch(() => {
              })
          }else{
            // // console.log(4)
            this.yogaSubmitOrder(param)
          }
        }
        return

        // var xiadan_date=(this.create_refund_date).replace(/-/g,"/")
        // var pdate=new Date()
        // var pdate_year = pdate.getFullYear()
        // var pdate_month = pdate.getMonth() + 1
        // if(pdate_month<10){pdate_month='0'+pdate_month}
        // var padte_day = pdate.getDate()
        // var dangqian_date=pdate_year+'/'+pdate_month+'/'+padte_day
        // if(new Date(xiadan_date).getTime() >= new Date(dangqian_date).getTime()){
        //   this.yogaSubmitOrder(param)
        // }else{
        //   this.$dialog.confirm({
        //     message: "您预约的是当天或第二天的日期，预订成功后将不可退订，请确认是否要继续预约？",
        //     confirmButtonColor: '#544590'
        //   }).then(() => {
        //     $this.yogaSubmitOrder(param)
        //   }).catch(() => {
        //   })
        // }
      },
      // 瑜伽下单
      yogaSubmitOrder(param){
        // console.log(param)
        this.yogaSubmitOrderBook(param);//v2.1.8后开始用新的下单接口，下面代码暂时停止执行
        return
        var $this = this
        this.$loading('正在创建订单');
        // let param = param;
        var qs = require('qs');
        let url = this.api.userApi.doYogaOrder
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // console.log(result)
          if(!result.data){
            $this.$toast(result.msg);
            $this.$loading.close()
          }else{
            if(result.data.pay_json == ""||result.data.pay_json == undefined||result.data.pay_json == null){
              var temp=[]
              setTimeout(() => {
                $this.$loading.close()
                $this.pay_success=true
                sessionStorage.removeItem('fullpage')
                // 我的会员卡列表发生变化，vuex 更新我的会员卡
                $this.$store.commit('setMyCards',temp)
              }, 300);
            }else{
              let config = JSON.parse(result.data.pay_json);
              // console.log(config)
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,2), false);
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,2));
                  document.attachEvent('onWeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,2));
                }
              } else {
                $this.onBridgeReady(config,result.data.order_no,2);
              }
            }
          }
        }).catch((error) => {
          // console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })
      },
      // 瑜伽v2.1.8下单
      yogaSubmitOrderBook(parameter){
        // bookYoga
        // console.log(parameter)
        // return
        var param={
          token:parameter.token,
          user_cards_id:parameter.user_cards_id,
          stadium_id:parameter.stadium_id,
          yoga_schedule_id:parameter.sd_course_schedule_id,
          user_coupon_id:parameter.user_coupon_id,
          num:parameter.order_cnt
        }
        // console.log(param)
        // return
        var $this = this
        this.$loading('正在创建订单');
        // let param = param;
        var qs = require('qs');
        let url = this.api.userApi.bookYoga
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // console.log(result)
          if(!result.data){
            $this.$loading.close()
            $this.$toast(result.msg);
          }else{

            if(result.data.pay_type=='wx'&&result.data.pay_json!=''){
              let config = JSON.parse(result.data.pay_json);
              // console.log(config)
              if (typeof WeixinJSBridge == "undefined") {
                if (document.addEventListener) {
                  document.addEventListener('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,2), false);
                } else if (document.attachEvent) {
                  document.attachEvent('WeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,2));
                  document.attachEvent('onWeixinJSBridgeReady', $this.onBridgeReady(config,result.data.order_no,2));
                }
              } else {
                $this.onBridgeReady(config,result.data.order_no,2);
              }
            }else{
              $this.fitFreePay(result.data.order_no)
            }


          }
        }).catch((error) => {
          // console.warn(error)
          $this.$loading.close()
          // $this.$toast('error');
        })
      },
      // 微信支付
      onBridgeReady(config,order_no,type) {
        var $this = this
        WeixinJSBridge.invoke('getBrandWCPayRequest', config,function(res) {
          if (res.err_msg == "get_brand_wcpay_request:ok") {
            $this.$store.commit('updataMycard', [])
            $this.$loading.close()
            // $this.$toast("预约成功");
            $this.pay_success=true

            sessionStorage.removeItem('fullpage')

          } else if (res.err_msg == "get_brand_wcpay_request:cancel") {
            $this.$loading.close()
            $this.$toast("支付失败,请重新支付");
            $this.cancelPay(order_no,type)
          } else {
            $this.$loading.close()
            $this.$toast("支付失败,请重新支付");
          }
        });
      },
      // 取消支付，释放库存
      cancelPay(order_no,type){
        var $this = this
        let param = {
          token: localStorage.getItem("token"),
          order_no:order_no,
          // type:type
        }
        // $this.$loading('正在加载~');
        // getCouponList
        var qs = require('qs');
        let url = this.api.userApi.bookCancelPay
        this.axios.post(url, qs.stringify(param), )
        .then((result) => {
          // // console.log(result)
        }).catch((error) => {
          // // console.warn(error)
        })
      },
      // 时间选择器（包含特俗和非特殊状况）
      selecetPickTime(){
        if(this.order_stadium.stadium_id=='100050'){
          this.vtRservesHpageFitOrderPicktime_guili=true
        }else if(this.order_stadium.stadium_id=='100045'){
          this.vtRservesHpageFitOrderPicktime_wst=true
        }else{
          this.vtRservesHpageFitOrderPicktime=!this.vtRservesHpageFitOrderPicktime
        }
      },
      vtRservesHpageFitOrderPicktime_filter(type, options){
        if (type === 'minute') {
          return options.filter(option => option % 30 === 0);
        }
        return options;
      },
      vtPickTimeSelectCancel(){
        this.vtRservesHpageFitOrderPicktime=false
      },
      vtPickTimeSelect(e){
        // // console.log(e)
        this.vt_showSelectPickTimeTXT=e
        this.vtRservesHpageFitOrderPicktime=false
      },
      onConfirmGuiLi(value, index){
        this.vt_showSelectPickTimeTXT=value
        this.vtRservesHpageFitOrderPicktime_guili=false
      },
      onCancelGuiLi(){
        this.vtRservesHpageFitOrderPicktime_guili=false
      },
      onConfirmwWst(value, index){
        this.vt_showSelectPickTimeTXT=value
        this.vtRservesHpageFitOrderPicktime_wst=false
      },
      onCancelWst(){
        this.vtRservesHpageFitOrderPicktime_wst=false
      },
      // 查看订单
      backOrder(){
        this.$router.push({
          name:'orderlist'
        })
      },
      // 返回首页
      backHome(){
        this.$router.push({
          name:'index'
        })
      },
      // 分享模块
      shareApp(){
        let that = this;
        const u = navigator.userAgent;
        const isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);
        // const baseurl = encodeURI((window.location.href).split('.cn')[0])+'.cn'//"http://test.official.unionfit.cn"; //本地测试地址
        if (isiOS) {
          wx.updateAppMessageShareData({
            title: '斐燃生活', // 分享标题
            desc: '全国高端酒店会员制专享平台，提供健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              // console.log('斐燃生活分享')
              // alert('wx.updateAppMessageShareData')
              // console.log(res)
            },
            fail(){
              // alert('fail wx.updateAppMessageShareData')
            }
          });
          wx.updateTimelineShareData({
            title: '斐燃生活', // 分享标题
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              // console.log('斐燃生活分享')
              // alert('wx.updateTimelineShareData')
              // console.log(res)
            },
            fail(){
              // alert('fail wx.updateTimelineShareData')
            }
          });
        } else {
          wx.onMenuShareAppMessage({
            title: '斐燃生活', // 分享标题
            desc: '全国高端酒店会员制专享平台，提供健身、瑜伽等服务', //分享描述
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              // console.log('斐燃生活分享')
              // alert('wx.onMenuShareAppMessage')
              // console.log(res)
            },
            fail(){
              // alert('fail wx.onMenuShareAppMessage')
            }
          });
          wx.onMenuShareTimeline({
            title: '斐燃生活', // 分享标题
            link: encodeURI((window.location.href).split('.cn')[0])+'.cn', // 分享链接
            imgUrl: 'https://unionfit-img.oss-cn-beijing.aliyuncs.com/fit_logo.jpg', // 分享图标
            success(res) {
              // console.log('斐燃生活分享')
              // alert('wx.onMenuShareTimeline')
              // console.log(res)
            },
            fail(){
              // alert('fail wx.onMenuShareTimeline')
            }
          });
        }
      }
    }
  }
</script>

<style lang="less" scoped="scoped">
  @vm_base: 1/750*100vw;
  .erweima{
    // border: 1*@vm_base solid red;
    width: 100%;
    padding-bottom: 60*@vm_base;
    .erweima1{
      // border: 1*@vm_base solid red;
      width: 100%;
      text-align: center;
      font-size: 24*@vm_base;
      padding: 150*@vm_base 150*@vm_base 0 150*@vm_base;

    }
    .erweima2{
      // border: 1*@vm_base solid red;
      width: 60%;
      margin-left: 20%;
      margin-top: 30*@vm_base;
      margin-bottom: 30*@vm_base;
    }
    .erweima3{
      // border: 1*@vm_base solid red;
      width: 100%;
      text-align: center;
      font-size: 24*@vm_base;
    }
  }
  // head
  .container{
    background: #F8F8F8;
  }
  .res_head{
  	position:relative;
  	z-index:12;
  	width:100%;
  	height:100*@vm_base;
  }
  .res_head__fixed{
  	position:fixed;
  	left:0;
  	top:0;
  	z-index:99;
  	background:#fff;
  	width:100%;
  	height:100*@vm_base;
  	.res_head__fixed__box{
  		display:flex;
  		width:100%;
  		height:100%;
  	}
  	.res_header__fixed__left,
  	.res_header__fixed__right{
  		width: 90*@vm_base;
  		height:100%;
  	}
  	.res_header__fixed__center{
  		width: calc(100% - 180*@vm_base);
  		height:100%;
  		// line-height:100*@vm_base;
  		text-align:center;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
  		.enname{
  		  width: 100%;
  		  color: #000000;
  		  text-align: center;
  		  font-size: 32*@vm_base;
  		  height: 40*@vm_base;
  		  line-height: 40*@vm_base;
  		  margin-top: 20*@vm_base;
  		  letter-spacing: 8*@vm_base;
  		}
  		.chname{
  		  width: 100%;
  		  color: #000000;
  		  text-align: center;
  		  font-size: 24*@vm_base;
  		  height: 24*@vm_base;
  		  line-height: 24*@vm_base;
  		  margin-top: 4*@vm_base;
  		}
  	}
    .back{
      float:left;
      width:80*@vm_base;
      height:100%;
      background:url(../../assets/images/base/nav_back.png) center center no-repeat;
      background-size:18*@vm_base auto;
    }
    .res_switch{
      float:right;
      width:80*@vm_base;
      height:100%;
      background:url(../../assets/images/base/Switch_photo.png) center center no-repeat;
      background-size:38*@vm_base auto;
    }
  }
  // 用户卡swiper
  .bb_reserve_switch_card{
    width: 100%;
    height: 426*@vm_base;
    background-size: 100% auto;
    background-repeat: no-repeat;
    position: relative;
    .bb_reserve_switch_card_block{
      position: absolute;
      bottom: 0;
      left: 0;
      width: 100%;
      height: 386*@vm_base;
      padding: 0 32*@vm_base;
      .bb_reserve_switch_card_block_swiper{
        width: 100%;
        border-radius: 12*@vm_base;
        .bb_reserve_switch_card_block_swiper_item{
          width: 100%;
          height: 386*@vm_base;
          border-radius: 12*@vm_base;
          background-size: 622*@vm_base auto;
          background-position: center;
          background-repeat: no-repeat;
          .bb_reserve_switch_card_block_swiper_item_txt{
            width: 100%;
            height: 386*@vm_base;
            text-align: left;
            position: relative;
            // border: 1px solid red;
            .bb_reserve_switch_card_block_swiper_item_txt_cont{
              position: absolute;
              top: 0;
              left: 0;
              width: 100%;
              padding:56*@vm_base 72*@vm_base;
              // border: 1px solid red;
              .bb_reserve_switch_card_block_swiper_item_txt_name{
                color: #C9CBCD;
                font-size: 41*@vm_base;
                // border: 1px solid red;
              }
              .bb_reserve_switch_card_block_swiper_item_txt_msg{
                font-size:24*@vm_base;
                font-weight:400;
                color:rgba(255,255,255,0.6);
                margin-top: 110*@vm_base;
                width: 100%;
                // border: 1px solid red;
                .bb_reserve_switch_card_block_swiper_item_txt_msg_1{
                  color: #FFFFFF;
                  font-size: 28*@vm_base;
                  height: 32*@vm_base;
                  line-height: 32*@vm_base;
                }
                .bb_reserve_switch_card_block_swiper_item_txt_msg_2{
                  margin-top: 24*@vm_base;
                  margin-bottom: 16*@vm_base;
                  height: 24*@vm_base;
                  line-height: 24*@vm_base;
                  span{
                    float: right;
                  }
                }
                .bb_reserve_switch_card_block_swiper_item_txt_msg_3{
                  height: 24*@vm_base;
                  line-height: 24*@vm_base;
                  span{
                    float: right;
                  }
                }
              }
            }
          }
        }
      }
      .swiper-button-next{
        width: 100*@vm_base;
        height: 100*@vm_base;
        background-image:url(../../assets/images/base/arrows_card_rightbc.png);
        background-size: 100*@vm_base auto;
        background-repeat: no-repeat;
        background-position: center;
        border: none;
        outline: none;
        margin-right:-32*@vm_base;
      }
      .swiper-button-next::after{
        content: '';
      }
      .swiper-button-prev{
        width: 100*@vm_base;
        height: 100*@vm_base;
        background-image:url(../../assets/images/base/arrows_card_leftbc.png);
        background-size: 100*@vm_base auto;
        background-repeat: no-repeat;
        background-position: center;
        border: none;
        outline: none;
        margin-left:-32*@vm_base;
      }
      .swiper-button-prev::after{
        content: '';
      }
    }
  }
  // 修改swiper基础属性
  .swiper-slide {
    text-align: center;
    display: -webkit-box;
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    -webkit-justify-content: center;
    justify-content: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    -webkit-align-items: center;
    align-items: center;
    width: 80%;
    img{
      width: 100%;
    }
    transform: scale(0.88);
    opacity: 0.3;
    transition: all 0.5s ease;
  }
  .swiper-slide-active{
    transform: scale(1.1) !important;
    opacity: 1 !important;
  }
  // 个人信息
  .rserves_hpage_fit_order_info{
    // margin-top: 382*@vm_base;
    font-size: 28*@vm_base;
    padding: 40*@vm_base 32*@vm_base 0 32*@vm_base;
    .rserves_hpage_fit_order_info_block{
      padding:32*@vm_base;
      background:rgba(255,255,255,1);
      box-shadow:0px 4px 20px 0px rgba(238,238,238,1);
      border-radius:12*@vm_base;
      .rserves_hpage_fit_order_info_block_myinfo{
        width: 100%;

        .rserves_hpage_fit_order_info_block_myinfo_title{
          width: 100*@vm_base;
          height: 92*@vm_base;
          line-height: 92*@vm_base;
          float: left;
          color: #999999;
          white-space: nowrap;
        }
        .rserves_hpage_fit_order_info_block_myinfo_value{
          width: calc(100% - 100*@vm_base);
          height: 92*@vm_base;
          line-height: 92*@vm_base;
          float: left;
          text-align: right;
          color: #333333;
        }
        .rserves_hpage_fit_order_info_block_myinfo_value_arriveTime{
          width: calc(100% - 100*@vm_base);
          height: 92*@vm_base;
          line-height: 92*@vm_base;
          float: left;
          text-align: right;
          color: #F7B500;
          label{
            display: inline-block;
            width: 12*@vm_base;
            height: 92*@vm_base;
            float: right;
            margin-left: 8*@vm_base;
            background-image: url(../../assets/images/base/orderArrow.png);
            background-position: center;
            background-size: 12*@vm_base auto;
            background-repeat: no-repeat;
          }
        }
      }
      .van-cell__title{
        color: #999999;
        font-size: 28*@vm_base;
      }
      .van-cell__value{
        font-size: 28*@vm_base;
        color: #333333;
      }
    }
  }
  // 亲友
  .rserves_hpage_fit_order_guest{
    padding: 40*@vm_base 32*@vm_base 0 32*@vm_base;
    .rserves_hpage_fit_order_guest_block{
      padding:32*@vm_base;
      background:rgba(255,255,255,1);
      box-shadow:0px 4px 20px 0px rgba(238,238,238,1);
      border-radius:12*@vm_base;
      .rserves_hpage_fit_order_guest_block_title{
        .guesttitle{
          color: #999999;
        }
        .guessteperUp{
          color: #333333;
          text-align: right;
          .guessteperUp_reduce{
            display: inline-block;
            width: 70*@vm_base;
            line-height: 54*@vm_base;
            height: 54*@vm_base;
            background: #F5F5F5;
            margin-top: 22*@vm_base;
            text-align: center;
            font-size: 38*@vm_base;
            border-radius: 6*@vm_base 0 0 6*@vm_base;
          }
          .guessteperUp_num{
            display: inline-block;
            width: 70*@vm_base;
            line-height: 54*@vm_base;
            height: 54*@vm_base;
            background: #FFFFFF;
            margin-top: 22*@vm_base;
            text-align: center;
          }
          .guessteperUp_add{
            display: inline-block;
            width: 70*@vm_base;
            line-height: 54*@vm_base;
            height: 54*@vm_base;
            background: #F5F5F5;
            margin-top: 22*@vm_base;
            text-align: center;
            font-size: 38*@vm_base;
            border-radius: 0 6*@vm_base 6*@vm_base 0;
          }
          .guessteperUp_inputname{
            width: 100%;
          }
          input{
            text-align: right;
          }
        }
        .rserves_hpage_fit_order_guest_block_title_guest{
          border-top: 1px solid #EBEBEB;
          margin-bottom: 28*@vm_base;
          .guestnum_dist{
            margin-top: 30*@vm_base;
            border-bottom: 1px solid #EBEBEB;
            .guessteperUp_reduce{
              display: inline-block;
              width: 70*@vm_base;
              line-height: 54*@vm_base;
              height: 54*@vm_base;
              background: #F5F5F5;
              margin-top: 22*@vm_base;
              text-align: center;
              border-radius: 6*@vm_base;
              font-size: 38*@vm_base;
            }
          }
        }
        .van-col{
          height: 92*@vm_base;
          line-height: 92*@vm_base;
          font-size: 28*@vm_base;
        }
      }
    }
  }
  // 价格
  .co{
    padding: 40*@vm_base 32*@vm_base 32*@vm_base 32*@vm_base;
    .co_block{
      width: 100%;
      background: #FFFFFF;
      padding-top: 8*@vm_base;
      padding-left: 32*@vm_base;
      padding-right: 32*@vm_base;
      box-shadow: 0px 4*@vm_base 20*@vm_base 0px #EEEEEE;
      border-radius: 12*@vm_base;
      .co_block_item{
        width: 100%;
        padding: 52*@vm_base 0 32*@vm_base 0;
        .co_block_item_row_title{
          color: #999999;
          font-size: 28*@vm_base;
        }
        .co_block_item_row_txt{
          color: #333333;
          font-size: 28*@vm_base;
          text-align: right;
          position: relative;
          .co_block_item_row_txt_arrow{
            display: inline-block;
            width: 26*@vm_base;
            background-image: url(../../assets/images/base/icon_arrow.png);
            background-size: 24*@vm_base auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          .co_block_item_row_txt_dis{
            padding-top: 10*@vm_base;
          }
          .co_block_item_row_txt_btn{
            position: absolute;
            width: 100%;
            height: 200%;

            top: 0;
            left: 0;
            // margin-top: -50%;
            background: none;
            margin-top: -20*@vm_base;
          }
        }

        .co_block_item_row_bold{
          color: #333333;
          font-size: 28*@vm_base;
          font-weight: bold;

        }
        .co_block_item_row_color{
          text-align: right;
          .co_block_item_row_color_price{
            text-align: right;
            color: #F7B500;
            font-size: 36*@vm_base;
            font-weight: bold;
            letter-spacing: 2*@vm_base;
          }
          .co_block_item_row_color_save{
            text-align: right;
            color: #999999;
            font-size: 28*@vm_base;
            padding-top: 8*@vm_base;
            white-space: nowrap;
          }
        }
      }
      .co_block_item_border{
        border-bottom: 1*@vm_base solid #EBEBEB;
      }
    }
  }
  .bb_coupon{
    width: 100%;
    padding: 0 32*@vm_base 60*@vm_base 32*@vm_base;
    .bb_coupon_item{
      width: 100%;
      border-radius: 12*@vm_base;
      margin-top: 40*@vm_base;
      position: relative;
      .bb_coupon_item_info{
        width: 100%;
        height: 216*@vm_base;
        background-repeat: no-repeat;
        background-size: 100% 216*@vm_base;
        position: relative;
        // width: 100%;
        // top: 0;
        // left: 0;
        // z-index: 100;
        .bb_coupon_item_info_left{
          width: calc(31.8% - 32*@vm_base);
          float: left;
          height: 100*@vm_base;
          line-height: 100*@vm_base;

          // padding: 0 32*@vm_base;
          margin: 0 0 0 32*@vm_base;
          margin-top: 57*@vm_base;
          text-align: center;
          font-size: 100*@vm_base;
          color: #FFFFFF;
          font-weight: 600;
          border-right: 1*@vm_base solid #7C7987;
          position: relative;
          label{
            position: absolute;
            top: 0;
            left: 0;
            height: 100*@vm_base;
            line-height: 36*@vm_base;
            margin-left: 8*@vm_base;
            margin-top: 10*@vm_base;
            font-size: 36*@vm_base;
          }
          span{
            position: absolute;
            bottom: 0;
            right: 0;
            // height: 100*@vm_base;
            line-height: 36*@vm_base;
            margin-right: 8*@vm_base;
            margin-bottom: 10*@vm_base;
            font-size: 36*@vm_base;
            vertical-align: bottom;
          }
          .bb_coupon_item_info_left_ycqy{
            line-height: 100*@vm_base;
            // line-height: 1;
            font-size: 40*@vm_base;
          }
          .bb_coupon_item_info_left_mj{
            font-size: 24*@vm_base;
            font-weight: normal;
            text-align: center;
            line-height: 1;
          }
        }
        .bb_coupon_item_info_leftlarge{
          font-size: 60*@vm_base;
          label{
            margin-top: 25*@vm_base;
          }
        }
        .bb_coupon_item_info_right{
          width: calc(68.2% - 1*@vm_base);
          float: left;
          height: 100*@vm_base;
          margin-top: 57*@vm_base;
          padding: 0 39*@vm_base 0 28*@vm_base;
          .bb_coupon_item_info_right_info{
            width: calc(100% - 120*@vm_base);
            height: 100*@vm_base;
            float: left;
            .bb_coupon_item_info_right_info_name{
              width: 100%;
              height: 50*@vm_base;
              line-height: 50*@vm_base;
              color: #FFFFFF;
              font-size: 32*@vm_base;
            }
            .bb_coupon_item_info_right_info_time{
              width: 100%;
              height: 50*@vm_base;
              line-height: 50*@vm_base;

              font-size: 24*@vm_base;
            }
          }
          .bb_coupon_item_info_right_btn{
            width: 120*@vm_base;
            height: 120*@vm_base;
            float: left;
            background-color: #FFFFFF;
            border-radius: 50%;
            margin-top: -10*@vm_base;
            display: flex;
            align-items: center;
            justify-content: center;

            font-size: 28*@vm_base;
            font-weight: bold;
            position: relative;
            img{
              width: 25*@vm_base;
              position: absolute;
              top: 0;
              right: 0;
              z-index: 1;
              margin-top: 36*@vm_base;
            }
          }
          .bb_coupon_item_info_right_isusered{
            width: 120*@vm_base;
            // height: 120*@vm_base;
            float: left;
            border-radius: 50%;
            margin-top: -10*@vm_base;
          }
        }
      }
      .bb_coupon_item_button{
        width:100%;
        padding: 0 32*@vm_base;
        height:72*@vm_base;
        background:rgba(255,255,255,1);
        border-radius: 0 0 12*@vm_base 12*@vm_base;
        box-shadow:0px 10*@vm_base 20*@vm_base 0px rgba(238,238,238,1);
        display: flex;
        align-items: center;
        font-size: 24*@vm_base;
        font-weight: 500;
        color:rgba(143,140,152,1);
      }
      .bb_coupon_item_buttonUnuse{ }
      .bb_coupon_item_mask{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 282*@vm_base;
        z-index: 99;
        background:rgba(255,255,255,1);
        box-shadow:0px 10px 20px 0px rgba(238,238,238,1);
        opacity:0.38;
      }
      .bb_coupon_item_buttona::after{
        background:rgba(255,255,255,0.6);
      }
      // .bb_coupon_item_panel{
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 288*@vm_base;
      //   z-index: 3;
      // }
      // .bb_coupon_item_mask{
      //   position: absolute;
      //   top: 0;
      //   left: 0;
      //   width: 100%;
      //   height: 288*@vm_base;
      //   z-index: 2;
      //   background:rgba(255,255,255,1);
      //   opacity:0.6;
      // }
    }
    .bb_coupon_empty{
      width: 100%;
      border-radius: 12*@vm_base;
      // margin-top: 40*@vm_base;
      .bb_coupon_empty_img{
        width: 419*@vm_base;
        margin: 0 auto;
        margin-top: 160*@vm_base;
      }
      .bb_coupon_empty_tips{
        width: 100%;
        text-align: center;
        color: #333333;
        font-size: 28*@vm_base;
        margin-top: 60*@vm_base;
      }
    }
  }
  .bb_coupon_reserve{
    height: 0;
    overflow: hidden;
    overflow-y: auto;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: -1;
    background: #FFFFFF;
    border-radius: 24*@vm_base 24*@vm_base 0 0;
    .bb_coupon_reserve_unselect{
      width: 36*@vm_base;
      height: 36*@vm_base;
      float: right;
      margin-top: -18*@vm_base;
      border: 1px solid #FFFFFF;
      border-radius: 50%;
    }
    .bb_coupon_reserve_selected{
      width: 36*@vm_base;
      height: 36*@vm_base;
      float: right;
      margin-top: -18*@vm_base;
      border-radius: 50%;
      background: url(../../assets/images/base/coupon_choice_right.png);
      background-size: cover;
    }
  }
  .bb_coupon_reserve_hei{
    height: calc(100vh - 190*@vm_base);
    z-index: 10;
    transition:all 0.5s ease-in;
  }
  .bb_coupon_listc_mask{
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: -2;
    width: 100%;
    height: 0;
    background: rgba(0,0,0,.7);
  }
  .bb_coupon_listc_maskc{
    z-index: 9;
    height: calc(100vh - 100*@vm_base);
    transition:all 0.5s ease-in;
  }
  .co_block_item_row_bold_select{
    display: inline-block;
    border-radius: 6*@vm_base;
    border: 1*@vm_base solid #F7B500;
    font-size: 22*@vm_base;
    font-weight: 500;
    color: #F7B500;
    padding: 0*@vm_base 11*@vm_base;
  }
  // 提交
  .submit{
    width: 100%;
    height: 208*@vm_base;
    margin-top: 10*@vm_base;
    .submit_pos{
      // position: fixed;
      // bottom: 0;
      // left: 0;
      width: 100%;
      padding: 40*@vm_base 32*@vm_base 0 32*@vm_base;
      background: #ffffff;

      .submit_pos_btn{
        width: 100%;
        background: #444054;
        border-radius: 12*@vm_base;
        text-align: center;
        padding: 27*@vm_base;
        font-size: 32*@vm_base;
        font-weight: 500;
        color: #FFFFFF;
        outline: none;
      }
      .submit_pos_tip{
        width: calc(100% + 64*@vm_base);
        font-size: 24*@vm_base;
        margin-left: -32*@vm_base;
        font-weight: 400;
        color: #C7C6CC;
        padding: 18*@vm_base 0 24*@vm_base 0;
        text-align: center;
        white-space: nowrap;
      }
    }
  }
  .submitcnm{
    width: 100%;
    margin-top: 10*@vm_base;
    .submit_pos{
      // position: fixed;
      // bottom: 0;
      // left: 0;
      width: 100%;
      padding: 40*@vm_base 32*@vm_base 40*@vm_base 32*@vm_base;
      background: #ffffff;

      .submit_pos_btn{
        width: 100%;
        background: #444054;
        border-radius: 12*@vm_base;
        text-align: center;
        padding: 27*@vm_base;
        font-size: 32*@vm_base;
        font-weight: 500;
        color: #FFFFFF;
        outline: none;
      }
    }
  }

  // 时间选择器
  .vt_rserves_hpage_fit_order_picktimeMask{
    background:rgba(255,255,255,1);
    position: fixed;
    bottom: 0;
    z-index: 198;
    width: 100%;
    height: 100vh;
    background: rgba(0,0,0,.3);
  }
  .vt_rserves_hpage_fit_order_picktime{
    // padding: 32*@vm_base;
    background:rgba(255,255,255,1);
    position: fixed;
    bottom: 0;
    z-index: 199;
    width: 100%;
    .van-picker__confirm{
      font-size: 16px;
    }
    .van-picker__cancel{
      font-size: 16px;
    }
  }
  // 支付成功
  .vision_payresult{
    width: 100%;
    height: calc(100vh - 90*@vm_base);
    background: #FFFFFF;
    padding-top: 88*@vm_base;
    overflow: hidden;
    overflow-y: auto;
    .vision_payresult_img{
      width: 83*@vm_base;
      margin: 0 auto;
      margin-bottom: 65*@vm_base;
      border-radius: 50%;
    }
    .vision_payresult_con{
      width: 100%;
      padding: 0 48*@vm_base;
      font-size: 28*@vm_base;
      color: #444054;
    }
    .vision_payresult_tip{
      color: #DF7027;
      font-size: 24*@vm_base;
      padding: 16*@vm_base 48*@vm_base;
    }
    .vision_payresult_btn{
      width: 100%;
      padding: 56*@vm_base 48*@vm_base 0 48*@vm_base;
      .vision_payresult_btn_order{
        width: calc(50% - 17*@vm_base);
        float: left;
        height:80*@vm_base;
        line-height: 80*@vm_base;
        text-align: center;
        color: #FFFFFF;
        font-size: 32*@vm_base;
        background:linear-gradient(147deg,rgba(68,64,84,1) 0%,rgba(68,64,84,1) 100%);
        border-radius:12*@vm_base;
      }
      .vision_payresult_btn_index{
        width: calc(50% - 17*@vm_base);
        float: right;
        height:80@vm_base;
        line-height: 80*@vm_base;
        text-align: center;
        border-radius:12*@vm_base;
        border:1px solid rgba(68,64,84,1);
        color: #444054;
      }
    }
  }

  .explain_shabiyaoqiu{
    padding: 0*@vm_base 32*@vm_base 0 32*@vm_base;
    width:100%;
    font-size:24*@vm_base;
    font-weight:400;
    color: #333333;
    margin-bottom: 40*@vm_base;
    div{
      background: #FFFFFF;
      border-radius: 12*@vm_base;
      padding: 32*@vm_base;
    }
  }
  .explain_shabiyaoqiu_sb{
    color: #A5865F;
    text-decoration: underline;
  }
  .cnm_maks{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100vh;
    z-index: 998;
    background: rgba(0,0,0,0.5);
  }
  .cnm_cont{
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    min-height: 60vh;
    z-index: 999;
    background: #FFFFFF;
    padding: 40*@vm_base 50*@vm_base 60*@vm_base 50*@vm_base;


    font-size: 24*@vm_base;
    font-weight: 400;
    color: #333333;
    line-height: 2;
    overflow: hidden;
    overflow-y: auto;
    .cnm_cont_item{
      font-size: 32*@vm_base;
      font-weight: bold;
    }
    .cnm_cont_itemm{
      position: relative;
      .cnm_cont_itemm_icon{
        position: absolute;
        top: 0;
        right: 0;
        padding: 40*@vm_base 32*@vm_base;
        margin-top: -40*@vm_base;
        margin-right: -50*@vm_base;
        img{
          width: 24*@vm_base;
          height: 24*@vm_base;
        }
      }
    }
  }
  .submit_pos_tip_cnd{
    height: 40*@vm_base;
  }
</style>



// WEBPACK FOOTER //
// src/components/createorder/createorder.vue